export default __webpack_public_path__ + "static/media/job_offer7_m.1b230a2f.jpg";